import React from "react";
import { Helmet } from "react-helmet";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { TID } from "@/constants/testIds";

const faqs = [
  {
    q: "A chi è rivolto Metodo di Mare?",
    a: "A chi guida persone, team o organizzazioni; a chi lavora nel digitale o vuole diventare un professionista certificato nel mondo digitale; a chi cerca una crescita personale che duri, non solo che acceleri. Non è per chi cerca scorciatoie o soluzioni senza disciplina.",
  },
  {
    q: "Cosa contiene il libro in concreto?",
    a: "15 capitoli divisi in due Parti — 'La Rotta' (storia, metodo, vendita, reti, digitale, cybersicurezza, unione) e 'Il Metodo' (valori, visione, prodotto di ruolo, metodo operativo, leadership, disciplina, professionisti digitali). Ogni capitolo include esercizi pratici da applicare prima di andare avanti.",
  },
  {
    q: "È un libro di motivazione?",
    a: "No. Come scrive Roccaro nella Prefazione: 'Questo libro non è stato scritto per motivare. È stato scritto per dare struttura.' Non troverai formule rapide né promesse di successo immediato, ma un metodo costruito sul campo e verificato nel tempo.",
  },
  {
    q: "Come si legge?",
    a: "Un capitolo alla volta. Fermati sugli esercizi. Applica prima di andare avanti. Il metodo funziona solo quando diventa pratica, accompagnata dai valori (Determinazione, Responsabilità, Disciplina, Reciprocità, Lavoro duro, Meritocrazia).",
  },
  {
    q: "Cos'è la consulenza gratuita di orientamento?",
    a: "All'interno del libro c'è l'accesso esclusivo per richiedere una consulenza gratuita di orientamento, per applicare il metodo alla tua specifica realtà professionale. È anche la porta d'accesso al percorso per diventare Consulente ed Educatore Digitale Tecnologico e di Sostenibilità — figura riconosciuta dalla Legge 4/2013 tramite A.C.D.T.",
  },
  {
    q: "Posso leggere un estratto prima di acquistare?",
    a: "Sì. Il Capitolo 1 — 'La mia storia' è scaricabile gratuitamente in PDF da questo sito. È il capitolo che racconta il sogno della libertà, l'esperienza sull'Amerigo Vespucci e la nascita del metodo.",
  },
  {
    q: "In quali formati è disponibile?",
    a: "Paperback (€19,90 · 188 pagine) e Kindle (€7,90) su Amazon. Spedizione standard inclusa per Amazon Italia, reso entro 14 giorni. Disponibile anche con Carta del Docente e Carta della Cultura.",
  },
];

export default function Faq() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a,
      },
    })),
  };

  return (
    <section
      id="faq"
      data-testid={TID.faqSection}
      className="py-24 md:py-32 border-t border-[#E5E1DA]"
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 mb-12">
          <div className="md:col-span-5">
            <p className="overline">Domande frequenti</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05]">
              Prima di
              <br />
              <em className="text-[#E89B6C]">salpare.</em>
            </h2>
          </div>
          <div className="md:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`${TID.faqItem}-${i}`}
                  className="border-b border-[#E5E1DA]"
                >
                  <AccordionTrigger className="font-serif-display text-xl md:text-2xl text-left text-[#0B192C] hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base font-light leading-relaxed text-[#3A4F6B] pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
